module.exports = __webpack_public_path__ + "img/Findoclogo.eabf552f.svg";